import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {

  constructor(){
    super();

    this.blogList = null;
    this.loadmore = null;
    this.loadedCounts = 0;
    this.default_rows = 1;
    this.onLoadMore = this.onLoadMore.bind(this);
    this.setLoadMore = this.setLoadMore.bind(this);
  }

  connectedCallback() {
    this.loadmore = this.querySelector('.loadmore');
    this.blogList = this.querySelectorAll(".blog-post-item");
    this.default_rows = this.dataset.defaultRows;

    if (this.dataset.loadMore == "true") {
      this.setLoadMore();
      this.loadmore?.addEventListener('click', this.onLoadMore);
    }
  }

   setLoadMore () {
    
    const cols = 3, rows = this.default_rows;
    this.loadedCounts = rows*cols;
    this.blogList.forEach((blog, index) => {
      if (index < this.loadedCounts) {
        blog.classList.add('loaded');
      }
    });
  }

  onLoadMore () {
    this.loadedCounts += 3;
    if (this.loadedCounts >= this.blogList?.length) {
      this.loadmore?.classList.add("hidden");
    }
    this.blogList.forEach((blog, index) => {
      if (index < this.loadedCounts) {
        blog.classList.add('loaded');
      }
    });
  }

}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
